import * as React from 'react';
import * as style from './style.css';
import { clsx } from 'clsx';
import { EInfrastructureType } from '../../../../containers/InfrastructureMapContainer';
import { UIText1 } from '@cian/ui-kit';

interface IInfrastructureTypeItemProps {
  checked: boolean;
  title: string;
  type: EInfrastructureType;
  icon: React.ReactNode;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const InfrastructureTypeItem: React.FC<IInfrastructureTypeItemProps> = ({
  checked,
  icon,
  type,
  title,
  handleChange,
}) => {
  return (
    <label
      aria-label={title}
      htmlFor={`infrastructure-map_${type}`}
      className={clsx(style['item'], checked && style['checked'])}
    >
      <input
        type="radio"
        name={'infrastructureMapTypes'}
        id={`infrastructure-map_${type}`}
        data-type={type}
        checked={checked}
        onChange={handleChange}
      />
      {icon}
      <UIText1>{title}</UIText1>
    </label>
  );
};
